import React, { useState, useEffect, useRef, useContext } from 'react';
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import AuthContext from  "../../context/AuthContext";
import { Button } from "primereact/button";
import { InputField } from "components/InputField/Input";
import { SaleValidationSchema } from 'utilities/ValidationSchema/Stock/SaleValidationSchema'; 
import useProductDataTable from './hook/useProductDataTable';
import { TableFormSale } from 'components/Table/TableFormSale';
import { AddSale } from 'services/sale/sale.service';

const SaleManually = () => {
    const { user } = useContext(AuthContext);
    const dispatch = useDispatch();
    const { saleAdd, saleAddLoading } = useSelector((state) => state.saleAdd);
    // console.log(saleAdd, saleAddLoading)


    // Initial value for sale
    const createInitialValue = {
        emp_code: "milon-123",
        shop: user.shop_id,
        sale_items: [
            {
                id: 0,
                item: "",
                remain_quantity: "",
                rate: "",
                sale_quantity: "",
                total_price_per_item: "",
            },
        ],
        total_price: 0,
    }

    // Formik
    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: SaleValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            // console.log('values: ', values)

            const modifiedData = {
                ...values,
                sale_items: values.sale_items.map((value) => {
                    return{
                        ...value,
                        item: value.item?.id,
                        rate: parseFloat(value.item?.rate),
                        remain_quantity: value.item.remain_quantity - value?.sale_quantity,
                        total_price_per_item: parseFloat((parseFloat(value.item?.rate) * value?.sale_quantity).toFixed(3))
                    }
                }),
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns, modalTableActionButton } = useProductDataTable(
        formik,
    );


    // form submit handler
    const handelSubmit = async (data) => {
        const modifiedData = {
            ...data,
            total_price: data.sale_items.reduce((accumulator, currentValue) => accumulator + currentValue.total_price_per_item, 0) //The accumulator parameter represents the accumulated value from previous iterations.
        }
        // console.log("modifiedData: ", modifiedData)

        await dispatch(AddSale(modifiedData)).then(() => {
            // hideModal();
            formik.resetForm();
            return
        });
    };


    return (
        <React.Fragment>
            <div className='grid'>
                <div className='col-9'>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="w-full">
                            <TableFormSale
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.sale_items}
                                loading={false}
                                dataKey="saleID"
                                type="sale"
                                actionButtonWidth={10}
                                actionButton={modalTableActionButton}
                            />
                        </div>
                        <div className='grid'>
                            <div className='col-10'>

                            </div>
                            <div className='col-2'>
                                <Button 
                                    type="submit"
                                    label={saleAddLoading ? "Loading" : "save"} 
                                    icon="pi pi-save"
                                    loading={saleAddLoading}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className='col-3'>
                    <div className="card">
                        <form onSubmit={formik.handleSubmit}>
                            <div className='w-full' style={{"textAlign": "center"}}>
                                Get Employee Information
                            </div>
                            <div className="w-full">
                                <InputField 
                                    label="Search Employee"
                                    name='employee_id'
                                    required={true}
                                    type='text'
                                    messagePosition='toast'
                                    width={12}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="card">
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default SaleManually;